import "./App.css";
import React from "react";
import UserList from "./components/UserList";

function App() {
  return (
    <div className="App">
      <UserList />
    </div>
  );
}

export default App;
